// Action creators for the batch payouts slice.
// One shared factory, one line per action.

import * as types from '../../lib/actionTypes.es6';

function creator(type) {
  return function create(payload) {
    return { type: type, payload: payload };
  };
}

// `status` is a REQUIRED query param on the list endpoint, so every fetch is
// scoped to one status — hence the status tabs rather than a single list.
export var getBatchPayoutsRequest = creator(types.GET_BATCH_PAYOUTS_REQUEST);
export var getBatchPayoutsSuccess = creator(types.GET_BATCH_PAYOUTS_SUCCESS);
export var getBatchPayoutsFailed = creator(types.GET_BATCH_PAYOUTS_FAILURE);

export var getBatchPayoutRequest = creator(types.GET_BATCH_PAYOUT_REQUEST);
export var getBatchPayoutSuccess = creator(types.GET_BATCH_PAYOUT_SUCCESS);
export var getBatchPayoutFailed = creator(types.GET_BATCH_PAYOUT_FAILURE);

// { guids }: the pending batches a refused create named, looked up so the
// error can quote their batch numbers.
export var resolveHeldBatchPayoutsRequest =
  creator(types.RESOLVE_HELD_BATCH_PAYOUTS_REQUEST);

export var createBatchPayoutRequest =
  creator(types.CREATE_BATCH_PAYOUT_REQUEST);
export var createBatchPayoutSuccess =
  creator(types.CREATE_BATCH_PAYOUT_SUCCESS);
export var createBatchPayoutFailed = creator(types.CREATE_BATCH_PAYOUT_FAILURE);
export var resetCreateBatchPayoutSuccess =
  creator(types.RESET_CREATE_BATCH_PAYOUT_SUCCESS);
export var resetCreateBatchPayoutError =
  creator(types.RESET_CREATE_BATCH_PAYOUT_ERROR);

// MONEY-MOVING. Guarded by a leading watcher plus the reducer's `submitting`
// flag so a double-click cannot dispatch twice.
export var payBatchPayoutsRequest = creator(types.PAY_BATCH_PAYOUTS_REQUEST);
export var payBatchPayoutsSuccess = creator(types.PAY_BATCH_PAYOUTS_SUCCESS);
export var payBatchPayoutsFailed = creator(types.PAY_BATCH_PAYOUTS_FAILURE);
export var resetPayBatchPayoutsSuccess =
  creator(types.RESET_PAY_BATCH_PAYOUTS_SUCCESS);
export var resetPayBatchPayoutsError =
  creator(types.RESET_PAY_BATCH_PAYOUTS_ERROR);

// Also money-moving in effect: it records that money has left, which is not
// something to do twice.
export var confirmBatchPayoutRequest =
  creator(types.CONFIRM_BATCH_PAYOUT_REQUEST);
export var confirmBatchPayoutSuccess =
  creator(types.CONFIRM_BATCH_PAYOUT_SUCCESS);
export var confirmBatchPayoutFailed =
  creator(types.CONFIRM_BATCH_PAYOUT_FAILURE);
export var resetConfirmBatchPayoutSuccess =
  creator(types.RESET_CONFIRM_BATCH_PAYOUT_SUCCESS);
export var resetConfirmBatchPayoutError =
  creator(types.RESET_CONFIRM_BATCH_PAYOUT_ERROR);

// Cancellable status poll. Payload: { guid }.
export var startBatchPayoutPolling =
  creator(types.START_BATCH_PAYOUT_POLLING);
export var stopBatchPayoutPolling = creator(types.STOP_BATCH_PAYOUT_POLLING);

// The agents of one agency, fetched so the builder can pay a whole agency.
// Payload: { agencyGuid }. Success and failure carry it back on meta.
export var getAgencyAgentsRequest = creator(types.GET_AGENCY_AGENTS_REQUEST);
export function getAgencyAgentsSuccess(data, request) {
  return {
    type: types.GET_AGENCY_AGENTS_SUCCESS,
    payload: data,
    meta: { agencyGuid: request && request.agencyGuid }
  };
}
export function getAgencyAgentsFailed(error, request) {
  return {
    type: types.GET_AGENCY_AGENTS_FAILURE,
    payload: error,
    meta: { agencyGuid: request && request.agencyGuid }
  };
}
